import React from 'react';
import './index.css';

// interface TextProps {
//     children: React.ReactNode;
//     className?: string; // Add className prop
//     heading?: boolean;
//     white?: boolean;
//     size?: number;
//     fontWeight?: number;
//     underline?: boolean;
//     margin?: number;
//     primary?: boolean;
//     grey?: boolean;
//     style?: React.CSSProperties;
//     textAlign?: 'center' | 'left' | 'right';
// }

const Text: React.FC<any> = ({
    children,
    className,
    heading,
    white,
    size = 16,
    fontWeight,
    underline,
    margin,
    primary,
    grey,
    ...rest
}) => {
    let dynamicClassName = '';
    if (heading) dynamicClassName += ' heading-text';
    if (primary) dynamicClassName += ' primary-text';
    if (white) dynamicClassName += ' white-text';
    if (grey) dynamicClassName += ' default-text';
    if (underline) dynamicClassName += ' underline';

    const mergedClassName = className ? `${className} ${dynamicClassName.trim()}` : dynamicClassName.trim();

    const style: React.CSSProperties = { fontSize: `${size}px`, margin: margin ? margin : 0 };

    if (fontWeight) style.fontWeight = fontWeight;

    return (
        <p className={mergedClassName} style={style} {...rest}>
            {children}
        </p>
    );
};

export default Text;
